import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import SurrenderDocumentsDrawer from "../ImprestSurrender/SurrenderDocumentsDrawer";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import {
  allImprestSurrender,
  imprestApplicationsByUser,
  leaveApplications,
  leaveApplicationsByUser,
  imprestApprover,
  approvedDisbursedImprests,
  allApprovedImprestSurrender,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import { AllImprestSurrenderColumns, LeaveApplicationsColumns, imprestApplicationsColumns } from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import ImprestSurrenderForm from "./form";

const base_url = HRService.uri;

function ApprovedImprestSurrendersTable() {
  const [docsDrawerOpen, setDocsDrawerOpen] = useState(false);
  const [selectedRecordForDocs, setSelectedRecordForDocs] = useState(null);

  const actions = {
  entity: "Approved Surrenders",

    ViewSurrenderLineByApplication: {
      key: "ViewSurrenderLineByApplication",
      button_name: "View Lines",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    ViewDocuments: {
      key: "ViewDocuments",
      button_name: "View Documents",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
      onClick: (row) => {
        setSelectedRecordForDocs(row);
        setDocsDrawerOpen(true);
      },
    },

  showStatus: true,
};

  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Approved Imprest Surrenders"
          subtitle="View all approved Imprest Surrenders"
          columns={AllImprestSurrenderColumns}
          FormComponent={ImprestSurrenderForm}
          query={allApprovedImprestSurrender}
          actions={actions}
          base_url={base_url}
        />
        <SurrenderDocumentsDrawer
          open={docsDrawerOpen}
          onClose={() => {
            setDocsDrawerOpen(false);
            setSelectedRecordForDocs(null);
          }}
          surrenderId={selectedRecordForDocs?.id}
        />
      </>
    </Box>
  );
}

export default ApprovedImprestSurrendersTable;